import { render, staticRenderFns } from "./veStuPunishTypeShow.vue?vue&type=template&id=238e7eec&scoped=true"
import script from "./veStuPunishTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuPunishTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e7eec",
  null
  
)

export default component.exports